import BlogServices from '../../services/blog';
import Blog from '../../model/post';

export const state = {
    blogs: [],
    blog: {},
}

export const mutations = {
    setBlog(state, blog) {
        state.blog = blog
    },
    setBlogs(state, blogs) {
        state.blogs = blogs
    },
    addBlog(state, blog) {
        state.blogs = [blog, ...state.blogs]
    },
}

export const getters = {
    getBlog(state) {
        return new Blog(state.blog);
    },
    getBlogs(state) {
        let blogs = state.blogs
        return blogs.map((p)=>{return new Blog(p)})
    },
}

export const actions = {
    get({commit}, id){
        return BlogServices.get(id)
        .then((response)=>{
            commit('setBlog', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return BlogServices.getAll(data)
        .then((response)=>{
            commit('setBlogs', response.data.data)
            return response
        })
    },
    add({commit}, blog){
        return BlogServices.add(blog)
        .then((response)=>{
            commit('addBlog', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, blog}){
        return BlogServices.edit(id, blog)
        .then((response)=>{
            let blogs = state.blogs
            blogs[blogs.findIndex((x)=>x.id == id)] = response.data
            commit('setBlogs', blogs)
            return response
        })
    },
    delete({commit}, id){
        return BlogServices.delete(id)
        .then((response)=>{
            commit('setBlogs', state.blogs.filter((x)=>x.id != id))
            return response
        })
    },
}